import type { GetV2ProviderPatientDocumentsByPatientIdListApiArg } from '@store/generated/patients';

import {
  useGetPatientDocumentsQuery
} from './api';

/**
 * Options for usePatientDocuments hook - provides a simpler interface
 * that maps to the generated API args
 */
export interface UsePatientDocumentsOptions {
  patientId: string;
  page?: number;
  perPage?: number;
  documentType?: string;
  includeDeleted?: boolean;
}

/**
 * Hook to get patient documents with optional callback support
 */
export function usePatientDocuments(
  options: UsePatientDocumentsOptions,
  queryOptions?: {
    skip?: boolean;
    pollingInterval?: number;
    refetchOnFocus?: boolean;
  },
) {
  // Map our simplified interface to the generated API args
  const args: GetV2ProviderPatientDocumentsByPatientIdListApiArg = {
    pathPatientId: options.patientId,
    page: options.page,
    perPage: options.perPage,
    documentType: options.documentType,
    includeDeleted: options.includeDeleted,
  };

  const result = useGetPatientDocumentsQuery(args, {
    skip: queryOptions?.skip,
    pollingInterval: queryOptions?.pollingInterval || 0,
    refetchOnFocus: queryOptions?.refetchOnFocus || false,
  });

  return {
    data: result.data?.items || [],
    total: result.data?.total || 0,
    page: result.data?.page || 1,
    perPage: result.data?.per_page || 20,
    totalPages: result.data?.total_pages || 0,
    isLoading: result.isLoading,
    isError: result.isError,
    isFetching: result.isFetching,
    error: result.error,
    refetch: result.refetch,
  };
}


